import { customerAccessTokenAtom } from "../atoms/authAtoms";
import { API, GraphQLResult } from "@aws-amplify/api";
import { Order } from "gpc-shared-types";
import { useAtom } from "jotai";
import { useState } from "react";
import { getOrder } from "../graphql/queries";

type OrderResult = GraphQLResult<{
  order: Order;
}>;

export const useOrder = () => {
  const [customerAccessToken] = useAtom(customerAccessTokenAtom);
  const [order, setOrder] = useState<Order | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchOrder = async (id: string, customerId?: string) => {
    if ((!customerAccessToken && !customerId) || !id) {
      return;
    }

    setLoading(true);
    try {
      const { data } = (await API.graphql({
        query: getOrder,
        variables: {
          customerAccessToken,
          customerId,
          id: `gid://shopify/Order/${id}`,
        },
      })) as OrderResult;

      if (!data?.order) {
        console.log(`No order found for id ${id}`);
        return;
      }

      setOrder(data.order);
    } catch (err: any) {
      if (err.errors) {
        console.error(
          `Unable to fetch order with id ${id}`,
          err.errors.flatMap((e: any) => JSON.parse(e.message)),
        );
        setError(err);
      } else {
        console.error("An unknown error occurred fetching orders", err);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    order,
    loading,
    error,
    fetchOrder,
  };
};
